export enum FrenzyKeys {
  A = 65,
  D = 68, // Dump game state for debugging
  J = 74, // Dump polygons as JSON
  P = 80,
  Q = 81,
  S = 83, // Toggle scaling - 1x/2x/3x/4x
  Z = 90
};

export enum FrenzyColor {
  RED = '#ff0000',
  BLUE ='#0000ff',
  GREEN ='#00ff00',
  YELLOW = '#ffff00',
  MAGENTA = '#ff00ff',
  CYAN = '#00ffff',
  WHITE = '#ffffff',
  BLACK = '#000000'
};

export const SCREEN_WIDTH = 640;
export const SCREEN_HEIGHT = 512;

export const LEVEL_COUNTER_INITIAL_VALUE = 2000;

export const WIDTH = 240;
export const MAX_X = WIDTH -1;
export const HEIGHT = 180;
export const MAX_Y = HEIGHT -1;

export const TOTAL_AREA = WIDTH * HEIGHT;

export const DEFAULT_DISPLAY_PIXEL_MULTIPLIER = 2;

